import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "enable-background": "new 0 0 40 45",
  viewBox: "0 0 40 45"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<filter id=\"a\" width=\"108%\" height=\"108%\" x=\"-4%\" y=\"-4%\"><feOffset in=\"SourceAlpha\" result=\"offOut\"></feOffset><feGaussianBlur in=\"offOut\" result=\"blurOut\" stdDeviation=\".5\"></feGaussianBlur><feBlend in=\"SourceGraphic\" in2=\"blurOut\"></feBlend></filter><path fill=\"none\" d=\"M0 0h40v45H0z\"></path><path fill=\"currentColor\" d=\"M12.5 34.7H5c-1.7 0-3-1.3-3-3v-26c0-1.7 1.3-3 3-3h30c1.7 0 3 1.3 3 3v26c0 1.7-1.3 3-3 3h-7.7L20 42.3z\" filter=\"url(#a)\"></path>", 3)
  ]))]))
}
export default { render: render }